import React, { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../Navbar"
import Sidebar from "../Sidebar"
import Footer from "../js/Footer"
import { fetchUserAction } from "src/stores/userSlice";
import { fetchAllEmployees } from "src/stores/employeeSlice";
import { fetchProjects } from "src/stores/projectSlice";
import { useDispatch, useSelector } from "react-redux"
import { AppContext } from "src/stores/ContextProvider";
import { selectUser } from "src/stores/userSlice";
import axios from "axios";
import moment from "moment";

export default function DashboardLayout() {
    const nav = useNavigate();
    const dispatch = useDispatch()
    const user = useSelector(selectUser);
    const [officeHolidays, setOfficeHolidays] = useState([]);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    useEffect(() => {
        dispatch(fetchUserAction())
        dispatch(fetchProjects())
    }, [dispatch])
    useEffect(() => {
        if (user && ( user.is_admin === "Yes" || user.role === "HR" || user.role === "Manager" || user.role_type === "Manager")) {
            dispatch(fetchAllEmployees())
        }
    }, [dispatch, user])

    useEffect(() => {
        const fetchHolidays = async () => {
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/leave/officeholiday`, {
                    year: moment().year(),
                });
                const filteredHolidays = (data || [])
                    .filter((el) => el.LOCATION === user?.country || (user?.country !== "India" && el.LOCATION !== "India"))
                    .map((el) => moment(el.DATE).format("YYYY-MM-DD"));
                setOfficeHolidays(filteredHolidays);
            } catch (error) {
                console.error("Failed to fetch office holidays", error);
            }
        };

        if (user?.country) {
            fetchHolidays();
        }
    }, [user?.country]);
    const location = useLocation();
    
    useEffect(() => {
        if(location.pathname === "/"){
            nav("/dashboard")
        }
        // Auto-close mobile sidebar when route changes
        if (isMobileMenuOpen) {
            setIsMobileMenuOpen(false);
        }
    }, [location.pathname, nav]);

    const overflowClass = ["/super-admin", "/admin", "/hr-panel"].includes(location.pathname)
        ? "overflow-y-auto overflow-x-hidden"
        : "overflow-y-auto overflow-x-hidden";

    const isTeamDirectory = location.pathname.includes("team") || location.pathname.includes("directory");
    return (
        <AppContext.Provider value={{ officeHolidays }}>
            <div className="flex h-screen overflow-hidden font-sans bg-white relative">
                {/* Mobile overlay */}
                {isMobileMenuOpen && (
                    <div 
                        className="fixed inset-0 top-[60px] bg-slate-900/50 z-30 md:hidden backdrop-blur-sm transition-opacity"
                        onClick={() => setIsMobileMenuOpen(false)}
                    />
                )}
                <Sidebar isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
                <div className="flex flex-col flex-1 min-w-0 w-full">
                    <Navbar isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
                    <main className="flex-1 relative bg-[#f6f6f6] flex flex-col">
                        <div className="absolute inset-0 bg-[#f6f6f6] rounded-tl-xl flex flex-col">
                            <div className={`flex-1 min-h-0 flex flex-col relative ${overflowClass}`}>
                                <div className={`flex-1 flex flex-col relative ${!isTeamDirectory ? '[&>div]:!overflow-visible [&>div]:!h-auto' : ''}`}>
                                    <Outlet />
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </AppContext.Provider>
    )
}

